export default {
  title: 'Gestisci il tuo business ovunque',
  description: 'Accedi al tuo account esistente.',
  form: {
    email: {
      label: 'Email',
      placeholder: 'Inserisci email',
    },
    password: {
      label: 'Password',
      placeholder: 'Inserisci password',
    },
    error_messages: {
      missing_info: 'Informazioni mancanti',
      wrong_credentials: 'Email o password errate',
    },
  },
  buttons: {
    login: 'Accedi',
    forgot_password: 'Password dimenticata',
  },
  white_label: {
    title: 'Accedi alla tua dashboard',
    form: {
      email: {
        label: 'Indirizzo email',
        placeholder: 'tu@ristorante.com',
      },
      password: {
        label: 'Password',
        placeholder: 'Inserisci la tua password',
      },
    },
    buttons: {
      login: 'Accedi',
    },
    intro: {
      eyebrow: 'Gestione ordini',
      headline: 'Gestisci il tuo ristorante ovunque.',
      description: 'Ordini, menu, orari di apertura e pagamenti — tutto in un unico posto.',
      features: {
        live: {
          title: 'In tempo',
          subtitle: 'reale',
        },
        instant: {
          title: 'Istantaneo',
          subtitle: 'modifica menu',
        },
        any_device: {
          title: 'Qualsiasi dispositivo',
          subtitle: 'telefono o tablet',
        },
      },
    },
  },
};
